/*
 * Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import { globalRef } from '@amazon/vinyl-util'

const marked = globalRef(() => new Set<Element>())

/** Marks a pressed link `data-navigating` until the router settles the navigation it started. */
export function markNavigating(link: Element): void {
    link.setAttribute('data-navigating', '')
    marked.value.add(link)
}

export function clearNavigating(): void {
    for (const link of marked.value) link.removeAttribute('data-navigating')
    marked.value.clear()
}
